import { useRef } from 'react';
import { initiatePromiseObject } from 'gw-portals-promise-js';

export default function usePromise() {
    const promiseObject = useRef(initiatePromiseObject()).current;

    return promiseObject;
}
